import { useCallback, useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip_v2";
import { cn } from "lib/utils";

export function SmartTooltip({ children, content, className, theme }) {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = ref.current;
    if (!el) return;

    const isOverflowing = el.scrollWidth > el.clientWidth;

    setIsTruncated((prev) => (prev !== isOverflowing ? isOverflowing : prev));
  }, []);

  useEffect(() => {
    checkTruncation();

    const resizeObserver = new ResizeObserver(checkTruncation);
    if (ref.current) resizeObserver.observe(ref.current);

    return () => resizeObserver.disconnect();
  }, [checkTruncation, children]);

  const text = (
    <span
      ref={ref}
      className={cn("truncate block", isTruncated && "cursor-help", className)}
    >
      {children}
    </span>
  );

  if (!isTruncated) return text;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{text}</TooltipTrigger>
      <TooltipContent theme={theme}>{content || children}</TooltipContent>
    </Tooltip>
  );
}
